import { styled } from 'styled-components';

import { SubmitButton as UnstyledSubmitButton } from 'components/Form/SubmitButton/SubmitButton';
import { transition } from 'theme/theme';

export const SubmitButton = styled(UnstyledSubmitButton)`
  svg {
    transition: transform ${transition};
  }

  &:hover,
  &:focus {
    svg {
      transform: translateX(50%);
    }
  }
`;
